import { useMemo } from "react"
import { Select, SelectOption, OnSelectCallback } from "./Select"

interface PredefinedSelectProps {
  value: string | undefined;
  predefined: string[];
  label: (value: string | undefined) => string;
  customValue: string;
  onSelect: OnSelectCallback;
  name: string;
  readOnly?: boolean;
  sort?: boolean;
  className?: string;
}

export function PredefinedSelect({ value, predefined, label, customValue, onSelect, name, readOnly, sort, className }: PredefinedSelectProps) {
  const selectedCustom = useMemo(() => !!value && predefined.indexOf(value) < 0, [value, predefined]);

  const options = useMemo(() => {
    const mapped: SelectOption[] = predefined.map((v): SelectOption => ({ title: label(v), value: v }));
    const ordered = sort ? mapped.toSorted((a, b) => a.title.localeCompare(b.title)) : mapped;
    if (selectedCustom && value) {
      ordered.push({ title: value, value });
    }
    return ordered;
  }, [predefined, label, sort, selectedCustom, value]);

  const button = (selectedCustom && value) ? value : label(value);

  return <Select button={button} customValue={customValue} name={name} value={value} onSelect={onSelect} options={options} readOnly={readOnly} className={className} />;
}
